import _ from 'underscore'
import $ from 'jquery'
import Ext from 'Ext'
import StringIndex from '../util/StringIndex'
import TokensHighlighter from '../util/TokensHighlighter'
import EmptyHighlighter from '../util/EmptyHighlighter'
import messageResource from '../messageResource'
import {DEFAULT_TIME_ZONE_GROUP_ID} from 'constants'
import Group from '../store/Group'
import {stringComparatorCaseSensitive, escapeHtmlSymbols} from '../atUtils'
import UserNameFormat from '../util/UserNameFormat'
import RemoteComboWithouLoadingState from '../util/RemoteComboWithouLoadingState'
import StringIndexDataProxy from '../util/StringIndexDataProxy'

// TODO strange thing
window.usersSelector;

function BaseUsersSelector() {
    var usersIndex;
    var users;
    var usersMap;
    var maxUserNameLength;
    var maxGroupNameLength;
    var groupsMap;
    var userNameLength;

    this.elementId = "singleUserSelector";

    this.usersCombo = null;

    this.initUsersGroupsStructures = function(allUsers, allGroups) {
        usersIndex = new StringIndex();
        users = allUsers;
        usersMap = {};
        maxUserNameLength = 0;
        maxGroupNameLength = 0;
        groupsMap = null;

        $.each(allUsers, function() {
            usersMap[this.id] = this;
            usersIndex.add(this.lastName, this.id);
            usersIndex.add(this.firstName, this.id);
            if (!_.isNull(this.middleName))
                usersIndex.add(this.middleName, this.id);
            userNameLength = this.formatNameLFM().length;
            if (!this.active)
                userNameLength += messageResource.getMessage("users_selector.disabled").length + 2;
            maxUserNameLength = Math.max(maxUserNameLength, userNameLength);
        });

        var addGroup = this.ugrEnabled ?
                       function(group) {
                           groupsMap[group.getId()] = group;
                           maxGroupNameLength = Math.max(maxGroupNameLength, group.getName().length);
                       } :
                       function(group) {
                           var len = group.getName().length;
                           if (group.id == DEFAULT_TIME_ZONE_GROUP_ID)
                               len += messageResource.getMessage("users_selector.default_group").length + 1;
                           groupsMap[group.getId()] = group;
                           if (len > maxGroupNameLength)
                               maxGroupNameLength = len;
                       };

        if (allGroups) {
            groupsMap = {};
            if (this.ugrEnabled) {
                var usersWithoutGroupUserGroup = new Group(window.SystemSettings.usersWithoutGroupId, messageResource.getMessage('common.users_without_group'));
                addGroup(usersWithoutGroupUserGroup);
            }

            $.each(allGroups, function() {
                addGroup(this);
            });
            var self = this;
            this.nameGroupFieldUser = this.ugrEnabled ? "userGroupId" : "timeZoneGroupId";
            // requires sorting by groupName.
            users.sort(function(user1, user2) {
                if (user1[self.nameGroupFieldUser] == user2[self.nameGroupFieldUser]) return stringComparatorCaseSensitive(user1.formatNameLFMU(),
                    user2.formatNameLFMU());
                if (user1[self.nameGroupFieldUser] == window.SystemSettings.usersWithoutGroupId) return -1;
                if (user2[self.nameGroupFieldUser] == window.SystemSettings.usersWithoutGroupId) return 1;

                var groupName1 = groupsMap[user1[self.nameGroupFieldUser]].getName();
                var groupName2 = groupsMap[user2[self.nameGroupFieldUser]].getName();

                var result = stringComparatorCaseSensitive(groupName1, groupName2);
                // unexpectable result since group ids is differ.
                if (result == 0) return stringComparatorCaseSensitive(user1.formatNameLFMU(), user2.formatNameLFMU());

                return result;
            });

            maxUserNameLength += 4;
        }

        //TODO: remove usage of the global variable
        window.usersSelector = this;
    };

    this.initSelector = function(emptyText, hiddenName, width, comboListClass) {
        if (_.isNull(width) || _.isUndefined(width)) width = 238;

        var userRecordType = Ext.data.Record.create(
            this.getData()
        );

        var usersProxy = new StringIndexDataProxy(usersIndex, "id", users);

        var store = new Ext.data.Store({
            proxy: usersProxy,
            reader: new Ext.data.ArrayReader({}, userRecordType)
        });

        var listWidth = Math.max(width, Math.min(400, Math.max(maxGroupNameLength * 6.7 + 6, maxUserNameLength * 6)));
        var paddingLeft = groupsMap ? 20 : 3;

        var userRowTemplate = '<div class="x-combo-list-item" style="' + (Ext.isIE ? 'width:' + listWidth - paddingLeft + 'px;' : '') + 'padding:3px 0 3px ' + paddingLeft + 'px">{[usersSelector.formatHighlightedUserName( values ) ]}</div>';


        var template;

        if (groupsMap) {
            var defaultGroupRenderer = function(groupId) {
                return escapeHtmlSymbols(window.usersSelector.getGroupName(groupId));
            };

            var groupRenderer = this.ugrEnabled ? defaultGroupRenderer : function(groupId) {
                var ret = defaultGroupRenderer(groupId);
                if (groupId == DEFAULT_TIME_ZONE_GROUP_ID) {
                    var groupName = ret;
                    var note = messageResource.getMessage("users_selector.default_group");

                    // if there is no scrollbar, then 7.5 is ok
                    var correction = -19.5;

                    ret = '<span class="defaultGroupName" title="' + groupName + '" style="width:' + (listWidth - note.length * 6.7 + correction) + 'px">' + groupName + '&nbsp;</span>' +
                          '<span class="defaultGroupNote" title="' + groupName + '">' + note + '</span>';
                }
                return ret;
            };

            template = new Ext.XTemplate(
                '<div>' +
                '   <tpl for="arguments[0]">' +
                '       <tpl if="xindex == 1 || parent[xindex - 2].groupId != values.groupId">' +
                '           <div class="users-selector-group-item" ' + (Ext.isIE ? 'style="width:' + listWidth + 'px"' : '') +
                '>{[this.renderGroup(values.groupId)]}</div>' +
                '       </tpl>' +
                userRowTemplate +
                '   </tpl>' +
                '</div>', {
                    renderGroup: groupRenderer
                }
            );
        }
        else {
            template = new Ext.XTemplate(
                '<div>' +
                '   <tpl for=".">' +
                userRowTemplate +
                '   </tpl>' +
                '</div>'
            );
        }


        if (Ext.isIE)
            listWidth += 18;

        var listClass = "singleUserSelector_list";
        if (Ext.isIE)
            listClass += " showVerticalScrollbar";
        if (comboListClass)
            listClass += " " + comboListClass;
        var self = this;
        this.usersCombo = new RemoteComboWithouLoadingState({
            selectorObject: self,
            width: width,
            minChars: 0,
            store: store,
            listClass: listClass,
            forceSelection: true,
            valueField: "id",
            triggerAction: "all",
            selectOnFocus: true,
            listWidth: listWidth,
            tokensHighlighter: new EmptyHighlighter(),
            emptyText: emptyText,
            hiddenName: hiddenName,
            tpl: template,

            setValue: function(v) {
                var text = v;
                var user = usersMap[v];
                if (user) {
                    text = self.formatUserName(v, user);
                } else if (this.valueNotFoundText !== undefined) {
                    text = this.valueNotFoundText;
                }
                this.lastSelectionText = text;
                RemoteComboWithouLoadingState.superclass.setValue.call(this, text);
                if (this.hiddenField) {
                    // we do it after calling super,
                    // because super sets hidden value the same as visible text
                    // and that's not what we want
                    this.hiddenField.value = v;
                }
                this.value = v;
            }
        });

        this.usersCombo.on("beforequery", function(qObj) {

            var searchTokens = usersIndex.getTokenizer().getTokens(qObj.query.toLowerCase());

            if (searchTokens.length == 0) {
                delete qObj.combo.store.baseParams.searchTokens;
                qObj.combo.tokensHighlighter = new EmptyHighlighter();
            }
            else {
                qObj.combo.store.baseParams.searchTokens = searchTokens;
                qObj.combo.tokensHighlighter = new TokensHighlighter(searchTokens, usersIndex.getTokenizer().getPunctuators());
            }

        });


        var self = this;
        this.usersCombo.on("select", function() {
            self.onUserSelect(self.usersCombo.getValue());
        });

        this.usersCombo.on("render", function() {
            self.onUsersComboRender();
        });

    };

    this.onUsersComboRender = function() {

    };

    this.getGroupName = function(groupId) {
        return groupsMap[groupId].getName();
    };

    this.hl = function(value) {
        return this.usersCombo.tokensHighlighter.highlightTokens(value);
    };

}

BaseUsersSelector.prototype.formatHighlightedUserName = function(value) {
    var formattedUserName = UserNameFormat.formatLFM(this.hl(value.firstName), this.hl(value.lastName), escapeHtmlSymbols(value.middleName));
    if (!value.active)
        formattedUserName = "<span class='disabledUser'>" + formattedUserName + " " + messageResource.getMessage("users_selector.disabled") + "</span>";
    return formattedUserName;
};
/**
 * Initializes users selector
 * @param users array of User elements
 * @param groups array of Group elements ( null if user groups are off )
 * @param initialValue id of selected user
 * @param emptyText text which will be shown if nothing is selected
 * @param hiddenFieldName name of a hidden input
 * @param width width of the selector
 * @return {*}
 */
BaseUsersSelector.prototype.init = function(users, groups, initialValue, emptyText, hiddenFieldName, width, comboListClass, ugrEnabled, tzgEnabled) {
    this.ugrEnabled = ugrEnabled;
    this.tzgEnabled = tzgEnabled;

    this.initUsersGroupsStructures(users, groups);
    this.initSelector(emptyText, hiddenFieldName, width, comboListClass);
    this.initialValue = initialValue;

    if (initialValue) this.usersCombo.setValue(initialValue);
    this.usersCombo.render(this.elementId);
    this.usersCombo.queryDelay = 1;

    return this;
};
BaseUsersSelector.prototype.getData = function() {
    var self = this;
    return [
        {name: 'id', mapping: "id"},
        {name: 'firstName', mapping: "firstName"},
        {name: 'lastName', mapping: "lastName"},
        {name: 'middleName', mapping: "middleName"},
        {name: 'username', mapping: "username"},
        {name: 'active', mapping: "active"},
        {name: 'groupId', mapping: self.nameGroupFieldUser}
    ]
};

BaseUsersSelector.prototype.rollbackSelection = function() {
    this.usersCombo.setValue(this.initialValue);
    this.usersCombo.blur();
};

BaseUsersSelector.prototype.formatUserName = function(v, user) {
    return user.formatNameLFM();
};

BaseUsersSelector.prototype.disable = function() {
    this.rollbackSelection();
    this.usersCombo.setEditable(false);
    this.usersCombo.disabled = true;
    this.usersCombo.blur();
};

BaseUsersSelector.prototype.enable = function() {
    this.usersCombo.setEditable(true);
    this.usersCombo.disabled = false;
};

BaseUsersSelector.prototype.onUserSelect = function(selectedUserId) {
    // abstract
};


export default BaseUsersSelector



// WEBPACK FOOTER //
// ./web/js/controls/BaseUsersSelector.js